// Themed histogram of pre-binned counts. Server returns
// `[{label, count}]` and we just render — no aggregation.

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import {
  chartTheme,
  tokens,
  tooltipContentStyle,
  tooltipItemStyle,
  tooltipLabelStyle,
} from "../lib/theme";

export interface HistogramBin {
  label: string;
  count: number;
}

export interface ChartHistogramProps {
  bins: HistogramBin[];
  color?: string;
  height?: number;
}

export default function ChartHistogram({
  bins,
  color = tokens.color.tealLight,
  height = 240,
}: ChartHistogramProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={bins} margin={{ top: 8, right: 12, bottom: 0, left: 0 }}>
        <CartesianGrid
          stroke={chartTheme.grid}
          strokeDasharray="3 6"
          vertical={false}
        />
        <XAxis
          dataKey="label"
          stroke={chartTheme.axis}
          tick={{ fill: chartTheme.axisText, fontSize: tokens.font.size.xs }}
          tickLine={false}
          axisLine={{ stroke: chartTheme.grid }}
        />
        <YAxis
          allowDecimals={false}
          stroke={chartTheme.axis}
          tick={{ fill: chartTheme.axisText, fontSize: tokens.font.size.xs }}
          tickLine={false}
          axisLine={false}
          width={40}
        />
        <Tooltip
          contentStyle={tooltipContentStyle}
          labelStyle={tooltipLabelStyle}
          itemStyle={tooltipItemStyle}
          cursor={{ fill: "rgba(0,212,170,0.06)" }}
        />
        <Bar dataKey="count" fill={color} radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
